import { useUserContext } from '../../../../../../../../providers/UserProvider/User.context';
import { useWorkspaceContext } from '../../../../../../../../providers/WorkspaceProvider/Workspace.context';
import { useChatContext } from '../../../../../../Chat.hook';

/**
 * INT-1505: the name of whoever scheduled the card, or undefined when unknown.
 * INT-1500 U11: any user of the workspace, not only the current user and the
 * lead's assignees: a colleague may schedule for a lead they are not on.
 */
export function useSchedulerName(createdBy: string): string | undefined {
  const { selectedChat } = useChatContext();
  const { currentUser } = useUserContext();
  const { workspaceInfo } = useWorkspaceContext();

  if (!createdBy) return undefined;
  if (createdBy === currentUser?.authId) return currentUser.name;
  return (
    workspaceInfo?.users?.[createdBy]?.name ||
    selectedChat?.lead?.users?.find((user) => user.auth_id === createdBy)?.name
  );
}
